import * as React from "react";

type CaseKeepLogoProps = React.SVGProps<SVGSVGElement>;

export function CaseKeepLogo({ className, ...props }: CaseKeepLogoProps) {
  return (
    <svg
      fill="currentColor"
      className={className}
      {...props}
      viewBox="0 0 755 809"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
    >
      <rect
        id="Artboard1"
        x="0"
        y="0"
        width="754.167"
        height="808.333"
        fill="none"
      />
      <g id="Background">
        <path d="M37.272,196.9c1.623,-121.134 -0.181,-121.042 0.689,-131.529c1.387,-16.716 7.708,-16.988 133.828,-26.45c33.702,-2.528 24.515,49.163 24.881,76.706c0.445,33.434 34.228,25.561 68.608,22.677c28.273,-2.372 12.945,-82.431 18.8,-97.813c4.997,-13.126 9.399,-11.877 175.295,-9.668c32.598,0.434 17.744,18.028 22.688,91.429c1.135,16.845 27.299,16.669 64.802,18.986c37.038,2.289 14.968,-75.23 24.313,-94.806c7.711,-16.154 147.072,3.172 151.556,5.264c11.445,5.339 9.479,8.932 7.912,157.67c-0.42,39.862 -33.979,58.897 -45.675,75.374c-8.837,12.451 26.837,276.85 33.202,368.229c8.204,117.777 20.457,128.846 -2.355,132.646c-7.972,1.328 -391.19,0.71 -425.206,0.655c-239.706,-0.387 -250.402,3.914 -250.677,-14.355c-0.055,-3.658 41.519,-430.786 45.522,-462.392c6.328,-49.96 -48.24,-34.51 -48.183,-112.624Zm460.728,118.184c-23.68,-36.206 -19.108,-41.647 -58.22,-60.178c-5.873,-2.783 -39.227,-18.585 -80.699,-9.375c-105.639,23.461 -100.409,150.557 -100.512,150.667c-15.654,16.671 -28.276,11.29 -28.678,50.684c-1.976,193.355 -2.579,196.428 10.654,206.331c25.164,18.832 274.268,11.805 285.643,3.367c27.023,-20.044 15.314,-26.203 15.135,-59.711c-0.655,-122.554 10.123,-179.174 -19.321,-193.975c-29.676,-14.918 -1.905,-29.294 -24.002,-87.81Z" />
        <path d="M428.115,399.059c-99.318,-0.454 -120.081,4.521 -120.397,-14.605c-2.095,-126.673 138.261,-114.577 153.015,-31.573c9.903,55.714 -19.834,45.67 -32.618,46.177Z" />
        <path d="M362.285,559.88c4.879,-34.025 -23.057,-29.705 -17.411,-63.37c11.393,-67.929 114.028,-19.132 74.567,29.901c-17.628,21.904 -12.286,24.1 -8.513,51.562c3.489,25.4 -38.35,17.438 -38.943,17.422c-20.343,-0.527 -9.931,-33.662 -9.7,-35.516Z" />
      </g>
    </svg>
  );
}
